// Utilities
import { getFeatureFlagInstance } from '../utils/feature-flags.utils';
import { isUserLogged } from 'utils/session/session.utils';
// Types
import type {
  FeatureFlagsHandlersPropsType,
  FeatureFlagsHandlersReturnType,
} from './types/feature-flags.handlers.types';

const loadFeatureFlagsHandler = async ({
  setFetching,
}: FeatureFlagsHandlersPropsType): Promise<void> => {
  const featureFlags = getFeatureFlagInstance();

  const userLogged = isUserLogged();
  try {
    await featureFlags.loadFeatureFlags(!userLogged);
  } catch (_) {
    console.error('Error loading feature flags');
  }

  setFetching(false);
};

const FeatureFlagsHandlers = ({
  setFetching,
}: FeatureFlagsHandlersPropsType): FeatureFlagsHandlersReturnType => ({
  handleLoadFeatureFlags: () => loadFeatureFlagsHandler({ setFetching }),
});

export { FeatureFlagsHandlers };
